import $ from 'jquery'

export function getDependence (moduleId, rulesObjectBlueprint) {
  updateCheckboxes()
  // dependence function
  if (window.eloquaForm['extraSettings'] && window.eloquaForm['extraSettings'][moduleId]) {
    let dependenceDefinition = window.eloquaForm['extraSettings'][moduleId]

    $.each(dependenceDefinition, function (key, definiton) {
      let dependenceElement = $('[name="' + key + '"]')
      $.each(definiton, function (dependenceValue, settings) {

        //dependenceElement.length === 1 --> text, textarea, single checkbox, select dropdown
        if (dependenceElement.length === 1) {

          //no value defined in document
          if (dependenceValue === 'noValue') {
            //set required validations -- NO VALUE set
            $.each(settings, function (i, settingDefinition) {
              let field = $('[name="' + settingDefinition.field + '"]')

              if (settingDefinition.required) {
                rulesObjectBlueprint[moduleId][settingDefinition.field]['required'] = {
                  depends: function () {
                    //handle no value checkbox (general true/false)
                    if (dependenceElement[0].type === 'checkbox' && !dependenceElement.hasClass('is-multiple')) {
                      return dependenceElement.is(':checked')
                      //handle no value select (general rule when ANY VALUE selected)

                    } else if (dependenceElement[0].type === 'select-one') {
                      return dependenceElement.val() !== 'default'
                    } else if (dependenceElement[0].type === 'text' || dependenceElement[0].type === 'textarea') {
                      return dependenceElement.val() !== ''
                    }
                  }
                }

                if (field[0].type === 'checkbox' || field[0].type === 'select-one') {
                  rulesObjectBlueprint[moduleId][settingDefinition.field]['valueNotEquals'] = 'default'
                }
              }
              if (settingDefinition.collapse) {
                if (field.closest('.formRow--col').prev().parent().hasClass('is-instruction-text')) {
                  field.closest('.formRow--col').prev().addClass('collapse')
                }
                field.closest('.formRow').parent().addClass('collapse')
              }
            })
          } else {
            // DROPDOWN dependenceElement.length === 1 + defined value
            $.each(settings, function (i, settingDefinition) {
              let field = $('[name="' + settingDefinition.field + '"]')

              if (settingDefinition.collapse) {
                if (field.closest('.formRow--col').prev().hasClass('is-instruction-text')) {
                  field.closest('.formRow--col').prev().addClass('collapse')
                }
                field.closest('.formRow').parent().addClass('collapse')
              }
              if (settingDefinition.required) {
                rulesObjectBlueprint[moduleId][settingDefinition.field]['required'] = {
                  depends: function () {
                    //handle DEFINED VALUE in dropdown
                    return dependenceElement.val() === dependenceValue
                  }
                }
                if (field[0].type === 'checkbox' || field[0].type === 'select-one') {
                  rulesObjectBlueprint[moduleId][settingDefinition.field]['valueNotEquals'] = 'default'
                }
              }
            })
          }
        } else {
          $.each(settings, function (i, settingDefinition) {
            let field = $('[name="' + settingDefinition.field + '"]')

            if (settingDefinition.required) {
              rulesObjectBlueprint[moduleId][settingDefinition.field]['required'] = {
                depends: function () {
                  if (key.indexOf('multi_checkboxes[]') > -1) {
                    return checkMultiCheckboxDependence(dependenceElement, dependenceValue)
                  } else {
                    //handle DEFINED VALUE in dropdown
                    return $('[name="' + key + '"]:checked').val() === dependenceValue
                  }
                }
              }
              if (field[0].type === 'checkbox' || field[0].type === 'select-one') {
                rulesObjectBlueprint[moduleId][settingDefinition.field]['valueNotEquals'] = 'default'
              }
            }

            if (settingDefinition.collapse) {
              let fieldFormRow = field.closest('.formRow')

              fieldFormRow.parent().addClass('collapse')
              if (field.closest('.formRow--col').prev().hasClass('is-instruction-text')) {
                field.closest('.formRow--col').prev().addClass('collapse')
              }

              if ($('[name="' + key + '"]:checked').val() === dependenceValue) {
                fieldFormRow.parent().collapse('show')

                if (field.closest('.formRow--col').prev().hasClass('is-instruction-text')) {
                  field.closest('.formRow--col').prev().collapse('show')
                }
              }
            }
          })
        }
      })

      dependenceElement.on('change', function (e) {
        $.each(window.eloquaForm['extraSettings'][moduleId][key], function (dependenceValue, settings) {
          if (dependenceValue === 'noValue') {
            $.each(settings, function (i, settingDefinition) {
              let field = $('[name="' + settingDefinition.field + '"]')

              if (settingDefinition.required) {
                if (field[0].type === 'checkbox' || field[0].type === 'select-one') {
                  if (dependenceElement[0].type === 'checkbox' && !dependenceElement.hasClass('is-multiple') && dependenceElement.is(':checked')) {
                    rulesObjectBlueprint[moduleId][settingDefinition.field]['valueNotEquals'] = 'default'
                  } else if (dependenceElement[0].type === 'select-one' && dependenceElement.val() !== 'default') {
                    rulesObjectBlueprint[moduleId][settingDefinition.field]['valueNotEquals'] = 'default'
                  } else if ((dependenceElement[0].type === 'text' || dependenceElement[0].type === 'textarea') && dependenceElement.val() !== '') {
                    rulesObjectBlueprint[moduleId][settingDefinition.field]['valueNotEquals'] = 'default'
                  } else {
                    delete rulesObjectBlueprint[moduleId][settingDefinition.field].valueNotEquals
                    field.rules('remove', 'valueNotEquals')
                  }
                }
              }

              if (settingDefinition.collapse) {
                let fieldFormRow = field.closest('.formRow')
                if (dependenceElement[0].type === 'checkbox' && !dependenceElement.hasClass('is-multiple') && dependenceElement.is(':checked')) {
                  if (field.closest('.formRow--col').prev().hasClass('is-instruction-text')) {
                    field.closest('.formRow--col').prev().collapse('show')
                  }
                  fieldFormRow.parent().collapse('show')
                } else if (dependenceElement[0].type === 'select-one' && dependenceElement.val() !== 'default') {
                  if (field.closest('.formRow--col').prev().hasClass('is-instruction-text')) {
                    field.closest('.formRow--col').prev().collapse('show')
                  }
                  fieldFormRow.parent().collapse('show')
                } else if ((dependenceElement[0].type === 'text' || dependenceElement[0].type === 'textarea') && dependenceElement.val() !== '') {
                  if (field.closest('.formRow--col').prev().hasClass('is-instruction-text')) {
                    field.closest('.formRow--col').prev().collapse('show')
                  }
                  fieldFormRow.parent().collapse('show')
                } else {
                  if (field.closest('.formRow--col').prev().hasClass('is-instruction-text')) {
                    field.closest('.formRow--col').prev().collapse('hide')
                  }
                  fieldFormRow.parent().collapse('hide')
                }
              }
            })
          } else {
            //reset all preselected field and hide collapsed fields
            $.each(settings, function (i, settingDefinition) {
              let field = $('[name="' + settingDefinition.field + '"]')
              let fieldFormRow = field.closest('.formRow')
              let placeholderElem = $(field[0]).siblings('.placeholder').find('.placeholder-text')
              let fieldPlaceholder = placeholderElem.text()

              if (settingDefinition.required) {
                if (key.indexOf('checkbox') == -1 && key.indexOf('radio') == -1) {
                  if ($(dependenceElement).val() == dependenceValue) {
                    if (fieldPlaceholder.indexOf('*') == -1) {
                      placeholderElem.html(fieldPlaceholder + '*')
                    }
                  } else {
                    if (fieldPlaceholder.indexOf('*') != -1) {
                      let resetPlaceholder = fieldPlaceholder.replace('*', '')
                      placeholderElem.html(resetPlaceholder)
                    }
                  }
                } else {
                  if (key.indexOf('multi_checkboxes[]') != -1) {
                    if (checkMultiCheckboxDependence(dependenceElement, dependenceValue)) {
                      if (fieldPlaceholder.indexOf('*') == -1) {
                        placeholderElem.html(fieldPlaceholder + '*')
                      }
                    } else {
                      if (fieldPlaceholder.indexOf('*') != -1) {
                        let resetPlaceholder = fieldPlaceholder.replace('*', '')
                        placeholderElem.html(resetPlaceholder)
                      }
                    }
                  } else {
                    if ($('[name="' + key + '"]:checked').val() == dependenceValue) {
                      if (fieldPlaceholder.indexOf('*') == -1) {
                        placeholderElem.html(fieldPlaceholder + '*')
                      }
                    } else {
                      if (fieldPlaceholder.indexOf('*') != -1) {
                        let resetPlaceholder = fieldPlaceholder.replace('*', '')
                        placeholderElem.html(resetPlaceholder)
                      }
                    }
                  }
                }
              }

              if (dependenceValue === e.target.value) {
                return
              }

              if (settingDefinition.required) {
                if (field[0].type === 'checkbox' || field[0].type === 'select-one') {
                  delete rulesObjectBlueprint[moduleId][settingDefinition.field].valueNotEquals
                  field.rules('remove', 'valueNotEquals')
                }
              }

              if (settingDefinition.collapse) {

                if (key.indexOf('multi_checkboxes[]') > -1) {
                  if (checkMultiCheckboxDependence(dependenceElement, dependenceValue)) {
                    if (field.closest('.formRow--col').prev().hasClass('is-instruction-text')) {
                      field.closest('.formRow--col').prev().collapse('show')
                    }
                    fieldFormRow.parent().collapse('show')
                  } else {
                    if (field.closest('.formRow--col').prev().hasClass('is-instruction-text')) {
                      field.closest('.formRow--col').prev().collapse('hide')
                    }
                    fieldFormRow.parent().collapse('hide')
                  }
                } else {
                  if (field.closest('.formRow--col').prev().hasClass('is-instruction-text')) {
                    field.closest('.formRow--col').prev().collapse('hide')
                  }
                  fieldFormRow.parent().collapse('hide')
                }
              }
            })

            //hande RADIO BUTTONS or VALUE DROPDOWNS
            $.each(window.eloquaForm['extraSettings'][moduleId][key][e.target.value], function (i, settingDefinition) {
              let field = $('[name="' + settingDefinition.field + '"]')
              let fieldFormRow = field.closest('.formRow')

              if (settingDefinition.required) {
                if (field[0].type === 'checkbox' || field[0].type === 'select-one') {
                  rulesObjectBlueprint[moduleId][settingDefinition.field]['valueNotEquals'] = 'default'
                  field.rules('add', {
                    'valueNotEquals': 'default'
                  })
                }
              }

              let element = $('[value="' + e.target.value + '"]')[0]
              if (settingDefinition.collapse && (element === undefined || element.checked || element.selected)) {
                if (field.closest('.formRow--col').prev().hasClass('is-instruction-text')) {
                  field.closest('.formRow--col').prev().collapse('show')
                }
                fieldFormRow.parent().collapse('show')
              } else if (settingDefinition.collapse) {
                if (field.closest('.formRow--col').prev().hasClass('is-instruction-text')) {
                  field.closest('.formRow--col').prev().collapse('hide')
                }
                fieldFormRow.parent().collapse('hide')
              }
            })
          }
        })
      })
    })
  }
  return rulesObjectBlueprint
}

function checkMultiCheckboxDependence (dependenceElement, dependenceValue) {
  let parent = dependenceElement.closest('.is-multiple-wrapper[data-active-checkbox]')
  let dataValue = parent.attr('data-active-checkbox')
  let arrayCheckboxes = dataValue.split(';')
  let multiDependence = dependenceValue.split(';')
  let show = false

  for (let i = 0; i < multiDependence.length; i++) {
    if (multiDependence[i].indexOf('&') != -1) {
      let dependence = multiDependence[i].split('&')

      if (dependence.length == arrayCheckboxes.length) {
        if (dependence.every(item => arrayCheckboxes.indexOf(item) != -1)) {
          show = true
        }
      }
    } else {
      if (multiDependence[i] == arrayCheckboxes[0] && arrayCheckboxes.length == 1) {
        show = true
      }
    }
  }

  return show
}

function updateCheckboxes () {
  let checkboxes = document.querySelectorAll('.eloqua-form input[type="checkbox"]')
  for (let i = 0; i < checkboxes.length; i++) {
    let checkBox = checkboxes[i]
    if (!checkBox.disabled) {
      checkBox.checked = false
    }
  }

  let checkboxContainer = $('.is-multiple-wrapper[data-active-checkbox]')

  if (checkboxContainer.length > 0) {
    checkboxContainer.each(function () {
      let checkbox = $(this).find('input[type=\'checkbox\']')

      checkbox.each(function () {
        $(this).on('click', function () {
          let checkboxVal = $(this).val(),
            checkboxData = checkboxContainer.attr('data-active-checkbox')
          if ($(this).is(':checked')) {
            if (checkboxData) {
              checkboxContainer.attr('data-active-checkbox', checkboxData + ';' + checkboxVal)
            } else {
              checkboxContainer.attr('data-active-checkbox', checkboxVal)
            }
          } else {
            if (checkboxData.endsWith(checkboxVal)) {
              if (checkboxData.indexOf(';') != -1) {
                let updatedCheckboxData = checkboxData.split(';' + checkboxVal)
                checkboxContainer.attr('data-active-checkbox', updatedCheckboxData[0])
              } else {
                let updatedCheckboxData = checkboxData.split(checkboxVal)
                checkboxContainer.attr('data-active-checkbox', updatedCheckboxData[0])
              }
            } else {
              let updatedCheckboxData = checkboxData.split(checkboxVal + ';')
              checkboxContainer.attr('data-active-checkbox', updatedCheckboxData[0] + updatedCheckboxData[1])
            }
          }
        })
      })
    })
  }
}
